module.exports = __webpack_public_path__ + "static/media/bonus-star.20a500bd.png";